import type {Point, RoutePoints} from '../model'

export const isRoutePoints = (points: Point[]): points is RoutePoints => points.length >= 2
